import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { getRespondent } from 'ducks/respondent'
import { WaveContainer } from 'components/quiz/WaveContainer/WaveContainer'
import InterestBar from './InterestBar/InterestBar'
import { useScrollToTop } from 'hooks'
import InterestQuestion from './InterestQuestion/InterestQuestion'
import InterestResults from 'components/interest/InterestResults/InterestResults'
import InterestWelcome from 'components/interest/InterestWelcome/InterestWelcome'
import styles from './InterestQuestionPage.module.scss'
import { toQuiz } from 'ducks/router'
import { t } from 'ttag'

const InterestQuestionPage = ({ id: uuid, interest, status, name, toQuiz }) => {
  const {
    state: { ref, scrollPosition },
    handlers: { handleScroll, handleScrollToTop },
  } = useScrollToTop()

  if (interest.status === 'created') {
    return <InterestWelcome />
  }

  if (interest.status === 'completed') {
    return (
      <WaveContainer containerRef={ref} handleScroll={handleScroll} rollUp>
        <InterestResults
          scrollPosition={scrollPosition}
          handleScrollToTop={handleScrollToTop}
        />
      </WaveContainer>
    )
  }

  if (!status && !name) {
    return (
      <WaveContainer rollUp>
        <div className={styles.noUserContainer}>
          <div className={styles.noUserMessage}>
            {t`Current respondent does not exist`}
          </div>
        </div>
      </WaveContainer>
    )
  }

  return (
    <WaveContainer
      finishButtonLabel={t`Exit`}
      handleExit={() => toQuiz({ uuid })}
      showFinishButton
      rollUp
    >
      <InterestQuestion />
      <InterestBar />
    </WaveContainer>
  )
}

export default connect(
  getRespondent,
  { toQuiz },
)(InterestQuestionPage)
